import { uniq } from 'lodash';
import Link from 'next/link';

import { useGetQueryFilters } from 'hooks/filters';

interface IProps {
  topics: string[];
}

export const StoryTileFooter = ({ topics }: IProps) => {
  const { filtersState } = useGetQueryFilters();
  const { topicFilters, url } = filtersState;

  return (
    <div className="pt-3 sm:pt-4">
      <ul className="-m-[3px] flex flex-row flex-wrap justify-start">
        {topics.map(topic => {
          url.searchParams.delete('topicFilter');

          uniq([...topicFilters, topic]).forEach(t =>
            url.searchParams.append('topicFilter', t),
          );

          return (
            <li key={topic}>
              <Link
                href={`${url.pathname}${url.search}`}
                className="m-[3px] block list-none rounded-full border border-black/30 bg-white/20 px-4 py-[5px] dark:border-white/30 dark:bg-black/20"
              >
                <span className="block text-[10px] text-black/80 dark:text-white">
                  {topic}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};